import React, {FunctionComponent} from 'react';

const disconnectedWta: FunctionComponent = () => {
  return (
    <div className='zchat__status'>
      <p className='zchat__status-text'>Write here to start your chat</p>
    </div>
  );
}

export default disconnectedWta;
